import React, { FunctionComponent } from 'react'
import { FieldRenderProps } from '@progress/kendo-react-form';
import StaffList from '../../User/ListControls/StaffList';

export const StaffField: FunctionComponent<FieldRenderProps> = props => {
    const { field } = props;
    const defVal = field.ConfigSettings?.DefaultValue;
    const multiSelect = field?.ConfigSettings?.Display === '1'
    const values = Array.isArray(field?.VALUES) ? field?.VALUES?.map(v => parseInt(v)) : [];
    const fieldChanged = (e) => {
        //console.log('fieldChanged',e);
        let fieldChange = { ...field, VALUES: e.value }
        props.onChange({ value: fieldChange });
    }
    return (
        <StaffList defaultValue={defVal} {...props} onChange={fieldChanged} multiSelect={multiSelect} values={values} />
    )

}

